<template>
    <section class="details-section" :class="{ borderless: noBorder, readonly }">
        <SectionHeader v-if="$slots && $slots.header">
            <slot name="header"></slot>
        </SectionHeader>

        <slot></slot>
    </section>
</template>

<script>
import SectionHeader from '@/components/SectionHeader';

export default {
    name: 'DetailsSection',
    components: {
        SectionHeader
    },
    props: {
        noBorder: Boolean,
        readonly: Boolean
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use '@/styles/bootstrap/variables' as bsvars;

section.details-section {
    border-bottom: 1px solid var(--border-color);
    padding: variables.$grid-padding 0;
    position: relative;

    &.borderless {
        border-bottom: none;
    }

    > * {
        margin-bottom: variables.$grid-padding;

        &:last-child {
            margin-bottom: 0;
            padding-bottom: 0;
        }
    }

    &.readonly::after {
        content: '';
        width: 100%;
        height: 100%;
        z-index: 100;
        background: rgba(bsvars.$light, 0.7);
        position: absolute;
        left: 0;
        top: 0;
        pointer-events: none;
    }
}
</style>
